// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"398":"3339c7e4711f8f84","502":"79391be70e878e8d"}[chunkId] + ".css";
};